import { Grid, Skeleton, Typography } from '@mui/material';
import { Box, Container } from '@mui/system';
import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from '@fortawesome/pro-light-svg-icons';
import { Link } from 'react-router-dom';
import HubspotForm from '../HubspotForm';

const HS_PORTAL_ID = "148454373";
const HS_FORM_ID = "54d0040a-7421-426a-b47b-238858c29fea";
const HS_REGION = "eu1";

const ContactGroup = ({ contact, loading }) => {

    return(
        <Box
            sx={{
                backgroundImage: `url(${contact?.background_image})`,
                backgroundSize: "cover",
                backgroundPosition: 'center',
                backgroundRepeat: "no-repeat",
                position: "relative",
            }}
        >
            <Box
                sx={{
                    position:'absolute',
                    width:'100%',
                    height:'100%',
                    background:"linear-gradient(90deg, rgba(13,96,168,1) 33%, rgba(0,0,0,0) 100%)",
                    mixBlendMode:'multiply'
                }}
            />
            <Container maxWidth='xl'>
                <Grid 
                    container 
                    spacing={0}
                    sx={{
                        position: 'relative',
                        zIndex: 1,
                        padding: '6rem 0',
                    }}
                >
                    <Grid 
                        item xs={12} 
                        md={5}
                    >
                        {loading ?
                            <>
                                <Skeleton 
                                    variant="rectangular"
                                    width="100%"
                                    height="50px"
                                    sx={{
                                        marginBottom: '12px',
                                    }}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height="50px"
                                    sx={{
                                        marginBottom: '1rem',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    sx={{
                                        marginBottom: '16px',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    sx={{
                                        marginBottom: '16px',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    sx={{
                                        marginBottom: '2rem',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    sx={{
                                        marginBottom: '16px',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    sx={{
                                        marginBottom: '2rem',
                                    }}
                                />
                            </>
                        :

                            <Box
                                sx={{
                                    color:'#fff',
                                }}
                            >
                                <Typography variant="h1" component="h1"
                                    sx={{
                                        fontSize:'3rem',
                                        fontWeight:600,
                                        mb:'1rem'
                                    }}
                                >
                                    {contact?.title}
                                </Typography>
                                <Typography 
                                    variant="body1" component="p" 
                                    dangerouslySetInnerHTML={{ __html: contact?.blurb }}
                                    sx={{
                                        mb:'2rem'
                                    }}
                                />
                                {contact?.contact.map((contactItem, index)=>(
                                    <Box key={index}>
                                        <Typography variant="body1" component="p" 
                                            sx={{
                                                fontWeight: 800,
                                                mb:'0.7rem'
                                            }}
                                        >
                                            {contactItem.address}
                                        </Typography>
                                        <Typography 
                                            variant="body1" 
                                            component="p"
                                            sx={{
                                                '& a':{
                                                    color: "#fff",
                                                    textDecoration: "underline!important",
                                                }
                                            }}
                                        >
                                            <FontAwesomeIcon 
                                                icon={faEnvelope} 
                                                style={{
                                                    marginRight: '0.5rem'
                                                }}  
                                            />
                                            <Link 
                                                to={`mailto:${contactItem.email}`}
                                            >
                                                {contactItem.email}
                                            </Link>
                                        </Typography>

                                        <Typography variant="body1" component="p"
                                            sx={{
                                                marginBottom: '2rem',
                                            }}
                                        >
                                            <FontAwesomeIcon 
                                                icon={faPhone}
                                                style={{
                                                    marginRight: '0.5rem'
                                                }}    
                                            />
                                            {contactItem.phone_number}
                                        </Typography>
                                    </Box>
                                ))} 
                            </Box>
                        }
                    </Grid>
                    <Grid item xs={0} md={2}></Grid>
                    <Grid 
                        item xs={12} 
                        md={5}
                        sx={{
                            backgroundColor: 'rgba(255,255,255,0.85)',
                            padding: '2rem',
                        }}
                    >
                        {loading ?
                            <>
                                <Box 
                                    sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        marginBottom: '16px'
                                    }}
                                >
                                    <Skeleton
                                        variant="rectangular"
                                        width="48%"
                                        height="44px"
                                    />
                                    <Skeleton
                                        variant="rectangular"
                                        width="48%"
                                        height="44px"
                                    />
                                </Box>
                                <Box 
                                    sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        marginBottom: '16px'
                                    }}
                                >
                                    <Skeleton
                                        variant="rectangular"
                                        width="48%"
                                        height="44px"
                                    />
                                    <Skeleton
                                        variant="rectangular"
                                        width="48%"
                                        height="44px"
                                    />
                                </Box>
                                <Box 
                                    sx={{ 
                                        marginBottom: '16px'
                                    }}
                                >
                                    <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height="44px"
                                    />
                                </Box>
                                <Box 
                                    sx={{ 
                                        marginBottom: '16px'
                                    }}
                                >
                                    <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height="274px"
                                    />
                                </Box>
                                <Skeleton
                                    variant="rounded"
                                    width="86px"
                                    height="35px"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    height="12px"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    height="12px"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    height="12px"
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    height="12px"
                                />
                            </>
                        :
                            <>
                                <HubspotForm
                                    portalId={HS_PORTAL_ID}
                                    formId={HS_FORM_ID}
                                    region={HS_REGION}
                                />
                                <Typography 
                                    variant="body1" component="p" 
                                    dangerouslySetInnerHTML={{ __html: contact?.policy }}
                                    sx={{
                                        fontSize: '12px'
                                    }}    
                                />
                            </>
                        }
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default ContactGroup;